import { useFormikContext } from 'formik'
import { ConditionModel } from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleForm/typings'
import { useMemo } from 'react'

export function useData() {
  const {
    values: { attribute, assignmentRuleConditionValues },
    touched,
    errors,
    status,
  } = useFormikContext<ConditionModel>()
  const {
    assignmentRuleConditionValues: assignmentRuleConditionValuesTouched,
  } = touched
  const { assignmentRuleConditionValues: assignmentRuleConditionValuesError } =
    errors

  const errorText = useMemo((): string => {
    if (
      attribute &&
      !!assignmentRuleConditionValuesTouched &&
      assignmentRuleConditionValuesError
    ) {
      return assignmentRuleConditionValuesError as string
    }

    return ''
  }, [
    assignmentRuleConditionValuesError,
    assignmentRuleConditionValuesTouched,
    attribute,
  ])

  return {
    errorText,
    value: assignmentRuleConditionValues?.sort() as string[],
    status,
  }
}
